<template><div><h1 id="zusagen" tabindex="-1"><a class="header-anchor" href="#zusagen"><span>Zusagen</span></a></h1>
<p>Zusagen — Definiert Zusagen</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>In dieser Tabelle können beliebig viele Zusagen definiert werden. Allerdings ist zu berücksichtigen, dass die Komplexität der Verwaltung und Bearbeitung mit der Anzahl der Zusagen steigt.</p>
<p>Pfad: <code v-pre>Personen → Tabellen → Zusagen → Zusagen</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Zusage</dt>
<dd>Zusage</dd>
<dt>Mandant</dt>
<dd>Mandant, Auswahl aus Tabelle Mandant</dd>
<dt>Beschreibung</dt>
<dd>Beschreibung, freies Textfeld für die Beschreibung der Zusage</dd>
<dt>bewirkt Status Z</dt>
<dd>Parametrisierung, ob eine Zusage im Personenstamm den Status &quot;Z&quot; auslösen soll.</dd>
<dt>Akq.-Ereignis zwingend</dt>
<dd>Parametrisierung, ob bei dieser Zusage ein Akquisitionsereignis erfasst werden muss.</dd>
<dt>Regionengruppe</dt>
<dd>Auswahl aus Tabelle Regionengruppe</dd>
<dt>aktiv bis</dt>
<dd>Gültigkeit der Zusage</dd>
<dt>Anzahl</dt>
<dd>Anzahl der aktuell aktiven Zusagen; wird online berechnet und angezeigt.</dd>
</dl>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
</div></template>


